<template>
  <div class="commodity-check" data-test="commodity-check">
    <van-form class="commodity-check-form" input-align="right" :label-width="110">
      <van-field
        readonly
        required
        clickable
        name="picker"
        label="盘点校区"
        :border="false"
        :right-icon="'arrow'"
        :input-align="'right'"
        placeholder="请选择"
        @click.stop="toChoiceCampus"
        v-model="campus.name"
      >
      </van-field>
      <div class="wrap">
        <template v-for="(item,index) in formData.goodsInventoryDetailList">
          <div class="item-list" :key="index">
            <van-cell
              class="itil"
              :title="item.goodsName"
              :border="false"
              style="background: rgba(var(--g2-rgb), 0.3)"
              :label="`${item.priceType == 2 ? `规格：${item.priceName}` : ''}`"
              >
                <template #right-icon>
                  <div class="del" @click="delCommodity(index)">
                    <van-icon name="delete-o" color="var(--g6)" />
                  </div>
                </template>
              </van-cell>
              <van-cell
                title="可售库存"
                :value="item.stock">
                <template #extra>
                  <span class="unit">{{item.unitName}}</span>
                </template>
              </van-cell>
              <van-field
                label="盘点后可售库存"
                required
                maxlength="6"
                v-model="item.inventoryStock"
                @input="NumberCheck($event, item)"
                placeholder="请输入">
                <template #extra>
                  <span class="unit">{{item.unitName}}</span>
                </template>
              </van-field>
          </div>
        </template>
        <div class="choose-btn" @click="chooseCommodity" v-if="formData.goodsInventoryDetailList.length<50">
          <van-icon
            class-prefix="vxs-icon"
            name="system_add"
            size="16"
            style="margin-right: calc(var(--gap) * 8)"
          />
          添加物品
        </div>
      </div>
      <van-cell title="盘点日期" 
        title-class="tctil" 
        is-link 
        required 
        :border="false"
        @click="chooseDate">
        <template>
          <div v-if="formData.inventoryDate">
            <div class="vu van-ellipsis">
              {{ formData.inventoryDate | filterDate }}
            </div>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>
      <div class="remark-box">
        <van-field
          type="textarea"
          v-model="formData.remark"
          autosize
          input-align="left"
          rows="3"
          maxlength="500"
          placeholder="请输入盘点备注信息"
          show-word-limit
          />
      </div>
    </van-form>
    <pageFooterBtn btnText="提交" :loading="submiting" loading-text="提交中..." @click="submit" />
  </div>
</template>

<script>
import pageFooterBtn from '@x3/vue/comp/page-footer-btn.vue';

export default {
  name: 'commodity-check',
  data() {
    return {
      pageTitle: '物品盘点',
      campus: app.teacher.campus,
      formData: {
        campusId: app.teacher.campus.id,
        inventoryDate: app.tool.date.filterDate(new Date()),
        goodsInventoryDetailList: [],
        remark: '',
      },
      submiting: false,
    }
  },
  filters: {
    filterDate(v) {
      return v && new Date(v) ? app.tool.date.filterDate(new Date(v)) : '请选择';
    },
  },
  methods: {
    NumberCheck(num, item) {
      let t = num.charAt(0);
      num = num.replace(/[^\d]/g, '');
      if (num) {
        // 不保留小数
        num = Number(num).toFixed(0);
      }
      if (t === '-') {
        num = '-' + num;
      }
      item.inventoryStock = num
    },
    // 选择盘点校区
    async toChoiceCampus () {
      let res = await app.x3.side.xsCampus({
          id: this.formData.campusId,
          config: {
            must: true,
          },
        });

      // 选中的校区发生变化，还需要清除已选物品
        this.campus = res;
        this.formData.campusId = res.id;
        this.formData.goodsInventoryDetailList = [];
    },
    // 添加物品
    async chooseCommodity() {
      if (!this.formData.campusId) {
        this.$toast('请先选择盘点校区');
        return;
      }
      let ret = await app.x3.side.xsGoods({
        params: {
          campusIds: [this.campus.id],
          campusList: [this.campus],
        },
        config: {
          id_key: 'priceItemId',
          show_price: false
        }
      });
      let commoditys = ret.list;
      if ((this.formData.goodsInventoryDetailList.length + commoditys.length) > 50) {
        commoditys = ret.list.slice(0,50-this.formData.goodsInventoryDetailList.length);
        vant.Toast.fail('最多添加50个物品。');
      }
      commoditys.forEach(goods => {
        if (this.checkRepeat(goods)) {
          vant.Toast.fail('请勿重复添加同一项目。');
        } else {
          this.formData.goodsInventoryDetailList.push({
            goodsId: goods.id,
            goodsName: goods.goodsName,
            priceItemId: goods.priceItemId,
            priceName: goods.priceItem.priceName,
            priceItem: goods.priceItem,
            unitName: goods.unitName,
            priceType: goods.commodityPriceType,
            stock: goods.priceItem.commodityGoodsStockList[0].surplusStock,
            inventoryStock: '',
          })
        }
      })
    },
    // 重复规格检查
    checkRepeat(obj) {
      let msg = '';
      for (let item of this.formData.goodsInventoryDetailList) {
        if (obj.priceItem.priceItemDetailId == item.priceItem.priceItemDetailId) {
          msg = '请勿重复添加同一项目。';
          break;
        }
      }
      return msg;
    },
    // 选择盘点日期
    async chooseDate() {
      let res = await app.x3.picker.calendar({
        defaultDate: this.formData.inventoryDate ? new Date(this.formData.inventoryDate) : new Date(),
        minDate: app.config.minDate,
        maxDate: new Date()
      });
      this.formData.inventoryDate = app.tool.date.filterDate(res);
    },
    // 删除项目
    delCommodity(index) {
      this.formData.goodsInventoryDetailList.splice(index, 1);
    },
    submit() {
      let f = this.formData;
      if (!f.campusId) {
        vant.Toast.fail('请输入盘点校区');
        return false;
      } 
      if (f.goodsInventoryDetailList.length == 0) {
        vant.Toast.fail('请添加盘点物品');
        return false;
      }
      let f1 = f.goodsInventoryDetailList.filter(item => String(item.inventoryStock).trim().length == 0);
      if (f1.length > 0) {
        vant.Toast.fail('请输入盘点后可售库存');
        return false;
      }
      if (!f.inventoryDate) {
        vant.Toast.fail('请选择盘点日期');
        return false;
      }
      this.showLoading();
      this.submiting = true;
      this.$api.commodityGoodsInventory(this.formData).then(res => {
        this.$toast.clear();
        this.submiting = false;
        if (res.code === 200) {
          this.$toast.success(`提交成功`);
          app.vue.$emit("refresh-commodity-list");
          setTimeout(() => {
            this.$router.back();
          }, 50);
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(err=>{
        console.log(err);
        this.submiting = false;
      });
    }
  },
  components: {
    pageFooterBtn
  }
}
</script>

<style lang="scss" scoped>
.commodity-check {
  display: flex;
  flex-direction: column;
  height: 100%;
  .commodity-check-form {
    flex: 1;
    .wrap {
      padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
      background: var(--g1);
      .item-list {
        margin-top: calc(var(--gap) * 12);
        border-radius: var(--radius-sm);
        overflow: hidden;
      }
      .choose-btn {
        margin-top: calc(var(--gap) * 12);
        height: calc(var(--w) * 70);
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--white);
        border-radius: var(--radius-sm);
        color: var(--c1);
        font-weight: bold;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
    }
    .van-cell {
      .tctil {
        color: var(--g7);
      }
      .unit {
        margin-left: calc(var(--gap) * 8);
      }
      .del {
        display: flex;
        align-items: center;
        font-size: 22px;
        padding-left: 10px;
      }
      &.itil {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      }
    }
    .remark-box {
      margin-top: calc(var(--gap) * 12);
    }
  }
}
</style>